export const FEET_PER_METER = 3.280839895; // exact enough
export const METER_PER_FOOT = 0.3048;
export const INCH_PER_MM = 0.03937007874;
export const MM_PER_INCH = 25.4;

// Length conversions (scalar)
export const ftToM = (ft) => ft * METER_PER_FOOT;
export const mToFt = (m) => m * FEET_PER_METER;

// Camber conversions
export const inToMm = (inch) => inch * MM_PER_INCH;
export const mmToIn = (mm) => mm * INCH_PER_MM;

// Area
export const sqftToSqm = (sqft) => sqft * 0.09290304;

// Perimeter/linear
export const ftToM_lin = ftToM;
export const mToFt_lin = mToFt;

// Weight
export const lbToKg = (lb) => lb * 0.45359237;
export const kgToLb = (kg) => kg / 0.45359237;

// Formatters
export const formatLength = (valueFt, units) =>
  units === 'metric' ? `${ftToM(valueFt).toFixed(2)} m` : `${valueFt} ft`;

export const formatCamber = (valueInch, units) =>
  units === 'metric' ? `${Math.round(inToMm(valueInch))} mm` : `${valueInch}"`;

export const formatArea = (lengthFt, widthFt, units) => {
  const sqft = lengthFt * widthFt;
  return units === 'metric'
    ? `${sqftToSqm(sqft).toFixed(1)} m²`
    : `${sqft.toLocaleString()} sq ft`;
};

export const formatPerimeter = (ft, units) =>
  units === 'metric' ? `${ftToM_lin(ft).toFixed(1)} m` : `${Math.round(ft)} ft`;

export const formatWeight = (lb, units) => {
  if (units === 'metric') {
    const kg = lbToKg(lb);
    const t = kg / 1000;
    return { main: `${Math.round(kg).toLocaleString()} kg`, aux: `(${t.toFixed(1)} t)` };
  }
  const tons = lb / 2000;
  return { main: `${Math.round(lb).toLocaleString()} lb`, aux: `(${tons.toFixed(1)} tons)` };
};